// extracted by mini-css-extract-plugin
export default {"cls1":"BackButton-cls1___cf97d22155721356edd","cls2":"BackButton-cls2__e7f270ec4d72b0a1bb82 BackButton-cls1___cf97d22155721356edd"};